import { render, staticRenderFns } from "./AcademicYearSetup.vue?vue&type=template&id=08341efa&"
import script from "./AcademicYearSetup.vue?vue&type=script&lang=js&"
export * from "./AcademicYearSetup.vue?vue&type=script&lang=js&"
import style0 from "./AcademicYearSetup.vue?vue&type=style&index=0&scss=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports